import React, { useState } from 'react';
import { Check, X, Building2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, date, errorText } from '../api';
import { Action, Field } from '../ui';

function useBusinessReview(business, onReviewed) {
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function review(approval) {
    if (note.trim().length < 3) { setError('Add a review note of at least 3 characters.'); return; }
    setBusy(true);
    setError('');
    try {
      await api.patch(`/admin/businesses/${business.id}`, { approval, note });
      toast.success(`Business ${approval}`);
      onReviewed();
    } catch (requestError) {
      setError(errorText(requestError));
    } finally { setBusy(false); }
  }
  return { note, setNote, busy, error, review };
}

export const BusinessReview = ({ business, onClose, onReviewed }) => {
  const model = useBusinessReview(business, onReviewed);
  return <section className="review-panel" data-testid="business-review-panel">
    <div className="section-heading"><h2><Building2 size={19} />{business.company}</h2>
      <button data-testid="close-business-review" aria-label="Close review" onClick={onClose}><X size={19} /></button></div>
    <dl className="profile-details">
      <div><dt>Contact</dt><dd>{business.name} · {business.email}</dd></div>
      <div><dt>GSTIN</dt><dd>{business.tax_id}</dd></div>
      <div><dt>Applied</dt><dd>{date(business.created_at)}</dd></div>
      <div><dt>Current status</dt><dd>{business.approval}</dd></div>
    </dl>
    <Field id="business-review-note" label="Review note / decision reason" area required
      value={model.note} onChange={event => model.setNote(event.target.value)} />
    {model.error && <div data-testid="business-review-error" className="notice error" role="alert">{model.error}</div>}
    <div className="form-actions">
      <Action id="reject-business" secondary busy={model.busy} onClick={() => model.review('rejected')}><X size={15} />Reject</Action>
      {business.approval !== 'pending' && <Action id="revoke-business" secondary busy={model.busy}
        onClick={() => model.review('pending')}>Return to review</Action>}
      <Action id="approve-business" busy={model.busy} onClick={() => model.review('approved')}><Check size={16} />Approve business</Action>
    </div>
  </section>;
};